import { useEffect } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from "@albo-ui/core";
import { MenuItem, Select, TextField, IconButton } from "@mui/material";
import { useCustomerAdd } from "./hooks/useCustomerAdd";
import { Search, Refresh } from "@mui/icons-material";

export const FeatureCustomerAdd = ({ changeAlert, changeLoader, onConfirm, onClose, open, title, customer }: any) => {
    const { form, loading: loadingTable, featureList, isValidForm, filters, zPos, onSelectFeature, changeValueSearch, featureSearch, onReset } = useCustomerAdd(open, changeAlert, customer);

    useEffect(() => {
        changeLoader(loadingTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    return (
        <Dialog open={open} onClose={onClose} style={{ display: zPos !== 45 ? "none" : null, minWidth: "600px" }}>
            <DialogTitle>
                <Typography variant="h2">{title}</Typography>
            </DialogTitle>
            <DialogContent style={{ paddingTop: 30 }}>
                <FlexGrid container spacing={2} style={{ width: 520, paddingTop: 15, paddingBottom: 25 }}>
                    <TextField
                        label={"Nombre"} value={filters["feature_name"] || ""} color="secondary" size="small" fullWidth
                        onChange={changeValueSearch.bind(this, "feature_name")}
                        InputProps={{
                            endAdornment: (
                                <IconButton onClick={featureSearch.bind(this)}>
                                    <Search />
                                </IconButton>
                            ),
                        }}
                    />
                    <TextField
                        label={"UUID"} value={filters["uuid"] || ""} color="secondary" size="small" fullWidth
                        onChange={changeValueSearch.bind(this, "uuid")}
                        InputProps={{
                            endAdornment: (
                                <IconButton onClick={featureSearch.bind(this)}>
                                    <Search />
                                </IconButton>
                            ),
                        }}
                    />
                    <IconButton onClick={onReset.bind(this)} sx={{ padding: "0 !important" }}>
                        <Refresh sx={{padding: "7px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#8bc179"}}/>
                    </IconButton>
                </FlexGrid>

                {featureList.length > 0 && (
                    <FlexGrid item fullWidth style={{ paddingBottom: 20 }}>
                        <Select MenuProps={{ style: { zIndex: 35001 } }} value={form.feature_uuid || "-1"} onChange={onSelectFeature.bind(this)} color="secondary" size="small" fullWidth>
                            <MenuItem value={"-1"} disabled>Beneficio</MenuItem>
                            {featureList?.map((item, index) => (
                                <MenuItem key={`feature-option-${index}`} value={item["uuid"]}>
                                    {item["feature_name"]}
                                </MenuItem>
                            ))}
                        </Select>
                    </FlexGrid>
                )}
            </DialogContent>

            <DialogActions>
                <FlexGrid fullHeight fullWidth justify="space-between" alignItems="space-between" style={{ marginTop: "20px", display: "flex" }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType="secondary" size="normal">
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item style={{ textAlign: "end" }}>
                        <Button onClick={() => onConfirm(form)} disabled={isValidForm} size="normal">
                            Aceptar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};
